import React from 'react'
import MaintenancePartList from './maintenancepartlist';
import { IMaintenancePartList } from './maintenancepartlistinterface';
 
const MaintenancePartListContainer = (props:IMaintenancePartList) => {
    return ( 
        <MaintenancePartList {...props} />
     );
}
 
export default MaintenancePartListContainer;